import * as React from 'react';
import { SVGProps } from 'react';

const IconDrillingPartRightStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0ZM5.5 9.969V2.031a4 4 0 0 0 0 7.938ZM9.969 6.5A4.002 4.002 0 0 1 6.5 9.969V6.5h3.469Zm0-1A4.002 4.002 0 0 0 6.5 2.031V5.5h3.469Z"
    />
  </svg>
);
export default IconDrillingPartRightStrokedSizeXs;
